import { Polygon } from '../robots.model';
import { TPrimitiveType } from './files.interface';
import { IRobotSentence } from './robots.interface';

export interface ILandmark {
  position: LandmarkPositionEnum;
  sentence: IRobotSentence;
}

/**
 * Especialmente usado quando faz um preview de um robô e retorna as âncoras encontradas.
 */
export interface ILandmarkFound {
  page: number;
  polygon: Polygon;
  processedValues: TPrimitiveType[];
  text: string;
  type: LandmarkPositionEnum;
}

export enum LandmarkPositionEnum {
  upFromLine = 1,
  rightFromLine = 2,
  downFromLine = 3,
  leftFromLine = 4,
}
